import { render, staticRenderFns } from "./RichTextBlock.vue?vue&type=template&id=33561790&scoped=true&"
import script from "./RichTextBlock.vue?vue&type=script&lang=js&"
export * from "./RichTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./RichTextBlock.vue?vue&type=style&index=0&id=33561790&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33561790",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
